// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"area_wrapper__1EHhQ"};